import type { QuerySettings } from '@customTypes/index';
import type { SearchParams } from '@customTypes/types';
import { useQuery } from '@tanstack/react-query';

import { getArtistsActivityList } from './request';

export const useGetArtistsActivityListQuery = (
  params: SearchParams,
  settings?: QuerySettings<typeof getArtistsActivityList>
) =>
  useQuery({
    queryKey: [
      'GetArtistsActivityList',
      params.pageNumber,
      params.referrerEmail,
      params.pageSize,
      params.FirstName,
      params.LastName,
      params.PhoneNumber
    ],
    queryFn: () =>
      getArtistsActivityList({
        config: {
          ...settings?.config,
          params: {
            pageNumber: 1,
            pageSize: 1000,
            referrerEmail: params.referrerEmail,
            FirstName: params.FirstName,
            LastName: params.LastName,
            PhoneNumber: params.PhoneNumber
          }
        }
      }),
    ...settings?.options
  });
